import { IconButton, Popover } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import React from 'react';
import Images from '../Utils/images';

interface Props {
  id: string;
  children: any;
  arrow?: boolean;
  closeButton?: boolean;
  anchorOrigin_vertical: 'bottom' | 'center' | 'top' | number;
  anchorOrigin_horizontal: 'center' | 'left' | 'right' | number;
  transformOrigin_vertical: 'bottom' | 'center' | 'top' | number;
  transformOrigin_horizonral: 'center' | 'left' | 'right' | number;
}
/**
 * CustomPopover component renders a button that toggles a popover element displaying additional content.
 * @example
 * <CustomPopover id="examplePopover" arrow={true} closeButton={true} anchorOrigin_vertical="top" anchorOrigin_horizontal="left" transformOrigin_vertical="center" transformOrigin_horizonral="right">
 *   <div>Popover content</div>
 * </CustomPopover>
 * @param {Props} props - Props description in one line containing id, children, arrow, closeButton, anchorOrigin_vertical, anchorOrigin_horizontal, transformOrigin_vertical, and transformOrigin_horizonral.
 * @returns {ReactElement} Renders an IconButton and Popover element on the page.
 * @description
 *   - Uses React state to track the element to anchor the Popover.
 *   - Handles Popover visibility using a boolean state derived from the anchor element.
 *   - Popover position can be customized through passed properties to the component.
 */
export default function CustomPopover(props: Props) {
  const {
    id,
    children,
    arrow,
    closeButton,
    anchorOrigin_vertical,
    anchorOrigin_horizontal,
    transformOrigin_vertical,
    transformOrigin_horizonral,
  } = props;

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        className="popoverPosition"
        disableRipple
        onClick={handleClick}
      >
        <HelpOutlineOutlinedIcon fontSize="small" />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className={arrow ? 'popoverArrow' : ''}
        anchorOrigin={{
          vertical: anchorOrigin_vertical,
          horizontal: anchorOrigin_horizontal,
        }}
        transformOrigin={{
          vertical: transformOrigin_vertical,
          horizontal: transformOrigin_horizonral,
        }}
      >
        {closeButton ? (
          <IconButton className="CloasePopover" onClick={handleClose}>
            <img src={Images.CLOSE} alt="Close" />
          </IconButton>
        ) : null}

        {children}
      </Popover>
    </>
  );
}
